export default "__VITE_ASSET__51de6d95__"